import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { ProductoService } from "src/app/services/producto.service";
import { RubroService } from "src/app/services/rubro.service";
import { TerritorioService } from "src/app/services/territorio.service";
import { VendedorService } from "src/app/services/vendedor.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import { SignalRMessageService } from "src/app/services/SignalRMessage.service";
import { ENVIRONMENT_FUNCTIONS } from "src/environments/environment";

@Component({
  selector: "app-productos-general",
  templateUrl: "./productos-general.component.html",
  styleUrls: ["./productos-general.component.scss"],
  providers: [SecurityService]
})
export class ProductosGeneralComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Modales
  @ViewChild('alert', { static: true }) alert: ElementRef;

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private rutUsuario: number
  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  optionsVendedor: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private vendedorService: VendedorService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private territorioService: TerritorioService,
    private productoService: ProductoService,
    private utilsService: UtilsService,
    private signalRMessageService: SignalRMessageService,
  ) {
    this.log = this.clog.log('REP. VTAS. TERRITORIOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10

    this.loadVendedores()
    this.loadRubros()

    this.createForm()
    this.formChangesSubscriptions()
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsVendedor = registros.map(vendedor => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }))
    })
  }

  private loadRubros() {
    this.rubroService.obtenerRubrosReporteVenta(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(rubro => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rubros: [[]],
      familias: [[]],
      vendedores: [[]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("rubros").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })

    this.formHeader.get("tipoVista").valueChanges.subscribe((tipoVista: string) => {
      if (tipoVista === this.RB_TIPO_VISTA_RESUMEN) {
        this.formHeader.get("vendedores").setValue([])
      }
    })
  }

  onRubroSelect(ev) {
    this.optionsFamilia = []

    const listaRubros = this.formHeader.get('rubros').value
    if (!listaRubros) return

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubroReporteVenta(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/

  /********* RESUMEN *********/
  resumenBuscarNotificacion(){
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    //this.resumen_paginationContext.CurrentPage = pageNumber
    this.resumen_listaMovimientos = [];
    this.resumen_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, rubros, familias } = this.formHeader.value
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 3,
        categoria_modulo_codigo: 4,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaRubro: rubros,
        listaFamilia: familias,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
      paginaActual: -1, //this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 // this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams
    this.sendMessage(inputParams);
  }

  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber
    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, rubros, familias } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaRubro: rubros,
        listaFamilia: familias,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 // this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.productoService.obtenerReporteVentaProductoGeneralResumido(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.resumen_loading = false
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta

      this.setCantidadFromDocumentos(registros)
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1
      this.resumen_loading = false

      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen()
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      monto_neto: this.calcularTotalMontoNeto(this.resumen_listaMovimientosAll),
      descuento: this.calcularDescuento(this.resumen_listaMovimientosAll),
      neto_total: this.calcularNetoTotal(this.resumen_listaMovimientosAll)
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.productoService.obtenerReporteVentaProductoGeneralResumidoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscarNotificacion(){
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    //this.detalle_paginationContext.CurrentPage = pageNumber
    this.detalle_listaMovimientos = [];
    this.detalle_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, rubros, familias, vendedores } = this.formHeader.value
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 4,
        categoria_modulo_codigo: 4,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaRubro: rubros,
        listaFamilia: familias,
        listaVendedor: vendedores,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
      paginaActual: -1, //this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))
    this.sendMessage(inputParams);
  }

  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    const { fechaDesde, fechaHasta, rubros, familias, vendedores } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaRubro: rubros,
        listaFamilia: familias,
        listaVendedor: vendedores
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.productoService.obtenerReporteVentaProductoGeneralDetallado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.detalle_loading = false
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.setCantidadFromDocumentos(registros)
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1

      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalles()
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      monto_neto: this.calcularTotalMontoNeto(this.detalle_listaMovimientosAll),
      descuento: this.calcularDescuento(this.detalle_listaMovimientosAll),
      neto_total: this.calcularNetoTotal(this.detalle_listaMovimientosAll )
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.productoService.obtenerReporteVentaProductoGeneralDetalladoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  /********* DETALLE *********/
  calcularStockFormatoPrincipal(listado: any) {
    console.log("calcularStockFormatoPrincipal");
    return this.utilsService.calcularStockFormatoPrincipal(listado);
  }

  calcularStockFormatoSecundario(listado: any) {
   return this.utilsService.calcularStockFormatoSecundario(listado);
  }

  calcularTotalMontoNeto(registros: any) {
     let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += item.precio_neto;
    });
    return Math.floor(costoTotal);
  };
  calcularDescuento(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += item.descuento;
    });
    return Math.floor(costoTotal);
  };
  calcularNetoTotal(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += item.monto_neto;
    });
    return Math.floor(costoTotal);
  };

  calcularMontoNetoTodosLosFormatos(listado: any, monto_neto_formato_principal:number) {
    return this.utilsService.calcularMontoNetoTodosLosFormatos(listado, monto_neto_formato_principal);
  }

  calcularDescuentoTodosLosFormatos(listado: any, descuento_formato_principal:number) {
    return this.utilsService.calcularDescuentoTodosLosFormatos(listado, descuento_formato_principal);
  }

  calcularNetoTotalTodosLosFormatos(listado: any, neto_total_formato_principal:number) {
    return this.utilsService.calcularNetoTotalTodosLosFormatos(listado, neto_total_formato_principal);
  }

  setCantidadFromDocumentos(registros: any) {
    registros.forEach(item => {
      item.precio_neto = 0;
      item.monto_neto = 0;
      item.neto_total = 0;
      item.descuento = 0;
      item.listaStockxUnidades.forEach(unidad => {
        unidad.cantidad = 0;
        unidad.precio_neto = 0;
        unidad.monto_neto = 0;
        unidad.neto_total = 0;
        unidad.descuento = 0;
        let _listaUnidadesxDocumento = item.listaUnidadesxDocumento.filter(lud => lud.formato_codigo  === unidad.formato_codigo);
        _listaUnidadesxDocumento.forEach(uxd => {
          if(uxd.tipo_dte_codigo !== 61) {
            unidad.cantidad += uxd.cantidad;
            unidad.precio_neto += uxd.precio_neto;
            unidad.monto_neto += uxd.precio_neto - uxd.monto;
            unidad.neto_total += uxd.monto_total;
            unidad.descuento += uxd.monto;
            console.log("_listaUnidadesxDocumento : monto_neto -> " + uxd.formato_codigo + " -> ", unidad.monto_neto);
          }
          else
          {
            unidad.cantidad -= uxd.cantidad;
            unidad.precio_neto -= uxd.precio_neto;
            unidad.monto_neto -= uxd.precio_neto - uxd.monto;
            unidad.neto_total -= uxd.monto_total;
            unidad.descuento -= uxd.monto;
          }
        })
        item.precio_neto += unidad.precio_neto;
        item.monto_neto += unidad.monto_neto;
        item.neto_total += unidad.neto_total;
        item.descuento += unidad.descuento;
      });
    });
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }
}
